import { UtilsService } from "@/services/utils/utils.service";
import { authorizedAPI } from "@/config/axios.config";

const utils = new UtilsService();

interface UserRef {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
}

interface CompanyRef {
  id: string;
  name: string;
}

interface PlanRef {
  id: string;
  displayName: string;
  priceInCents?: number;
}

export interface AdminDashboardOverview {
  kpis: {
    users: {
      total: number;
      last30Days: number;
      changePct: number | null;
    };
    revenue: {
      totalInCents: number;
      last30DaysInCents: number;
      changePct: number | null;
    };
    deployments: {
      up: number;
      total: number;
      provisioning: number;
      failed: number;
    };
  };
  pendingDeployments: Array<{
    subscriptionId: string;
    subscriptionStatus: string;
    deploymentStatus: string | null;
    company: CompanyRef | null;
    user: UserRef | null;
    plan: PlanRef | null;
    createdAt: string;
  }>;
  downDeployments: Array<{
    deploymentId: string;
    subscriptionId: string | null;
    company: CompanyRef | null;
    user: UserRef | null;
    plan: PlanRef | null;
    frontendDomain: string;
    backendDomain: string;
    lastHeartbeatAt: string | null;
  }>;
  revenueTrend: Array<{ month: string; totalInCents: number }>;
}

export interface UserDashboardOverview {
  subscription: {
    id: string;
    status: string;
    currentPeriodStart: string;
    nextPaymentAt: string;
    plan: PlanRef | null;
  } | null;
  deployment: {
    id: string;
    provisioningStatus: string;
    liveStatus: "UP" | "DOWN";
    frontendDomain: string;
    backendDomain: string;
    deployedAt: string | null;
    lastHeartbeatAt: string | null;
  } | null;
}

class DashboardService {
  async getAdminOverview(months = 6): Promise<AdminDashboardOverview> {
    return utils.handleApiRequest<AdminDashboardOverview>(() =>
      authorizedAPI.get("/dashboard/admin", { params: { months } })
    );
  }

  async getUserOverview(): Promise<UserDashboardOverview> {
    return utils.handleApiRequest<UserDashboardOverview>(() =>
      authorizedAPI.get("/dashboard/me")
    );
  }
}

export const dashboardService = new DashboardService();
